<div *ngIf="search.totalResults > 0" class="sort-widget">
    <label for="sort">Sort by </label>
    <select [(ngModel)]="sort" class="form-control" name="sort" (change)="sortChange($event)">
        <option value="ascending">A-Z</option>
        <option value="descending">Z-A</option>
        <option *ngIf="state?.lat && state?.lng" value="distance">Distance</option>
    </select>
</div>